export default "__VITE_ASSET__BFXiXMSH__"